<script>
import axios from "axios";

export default {
  name: 'ListField',
  emits: [
      'updated',
      'saving',
      'saved'
  ],
  props: {
    field: Object,
    item: Object,
    owner:String,
    list:String

  },
  data(){
    return {
      isEditing: false,
      errors: null,
      orgValue: null
    }
  },
  methods: {
    token(){
      return this.$root.$el.parentElement.dataset.token
    },
    startEdit(){
      if(!this.isInlineEditSupported) return
      this.isEditing = true
      setTimeout(() => {
        this.$refs.input.focus()
      }, 100)

    },
    stopEdit(value){
      if(this.value === value) return
      this.editItemField(value)
    },
    submitEdit(){
      let value = this.$refs.input.value

      this.editItemField(value)
    },
    cancelEdit(){
      this.isEditing = false
      this.item[this.field.code].value = this.orgValue
      this.errors = null
    },
    editItemField(value){
      this.isLoading = true
      this.item[this.field.code].value = value
      this.$emit('saving')
      axios.postForm(`${this.basePath()}lists/edit_list_item_field`, {
        uuid: this.item.uuid,
        list: this.list,
        field: this.field.id,
        value: value,
        owner: this.owner,
        _token: this.token()
      }).then( response => {
        this.errors = null;
        if(response.data.status === 'error'){
          let errors = [];
          for (let k in response.data.errors){
            errors.push(response.data.errors[k])
          }
          if(errors.length){
            this.errors = errors.join(', ')
          }
        }else if (response.data.status === 'ok'){
          this.$emit('updated')
          this.isEditing = false
          this.orgValue = value
        }
      }).catch( error => {
        // handle error
      }).finally( () => {
        this.$emit('saved')
      })
    },
  },
  computed: {
    render(){
      if(this.item[this.field.code]){
        return this.item[this.field.code].render
      }
      return '-'
    },
    value(){
      if(this.item[this.field.code]){
        return this.item[this.field.code].value
      }
      return ''
    },
    isInlineEditSupported(){
      return false;
      //return ['text'].indexOf(this.field.type) > -1
    }
  },
  mounted() {
    this.orgValue = this.value
  },
}
</script>

<template>
  <div v-if="!isEditing" @dblclick="startEdit">
    <span v-html="render"></span><i class="fa-solid fa-pen ms-1" v-if="isInlineEditSupported" @click="startEdit" role="button"></i>
  </div>

  <div v-if="isEditing">
    <div class="input-group" :class="{'is-invalid': this.errors !== null}">
      <input v-if="field.type === 'text'" ref="input" type="text" class="form-control form-control-sm"  :class="{'is-invalid': this.errors !== null}" :value="value">
      <button class="btn btn-outline-secondary" type="button" @click="cancelEdit"><i class="fa-solid fa-xmark"></i></button>
      <button class="btn btn-outline-success" type="button" @click="submitEdit"><i class="fa-solid fa-check"></i></button>
    </div>
    <div class="invalid-feedback">{{ errors }}</div>
  </div>
</template>

<style scoped>

</style>